//For basic page grid
jQuery(document).ready(function() {
    var gridRow = jQuery('.grid-row');
    if (gridRow.find('.second-sidebar').length > 0 && gridRow.find('.first-sidebar').length > 0) {
      jQuery('.usa-layout-docs__main').removeClass('desktop:grid-col-fill').addClass('desktop:grid-col-6');
    }
    else if (gridRow.find('.second-sidebar').length === 0 && gridRow.find('.first-sidebar').length > 0) {
      jQuery('.usa-layout-docs__main').removeClass('desktop:grid-col-fill').addClass('desktop:grid-col-9');
    }
  });